import { stringIsNumber } from './string.extentions';

export function getValues(value) {
  return Object.keys(value)
    .filter(stringIsNumber)
    .map((key) => value[key]);
}

export function getKeyValues<T>(
  value: T,
  transform?: (value: keyof T) => string
) {
  return (Object.keys(value) as Array<keyof T>)
    .filter((key) => isNaN(Number(key)))
    .filter(
      (key) => typeof value[key] === 'number' || typeof value[key] === 'string'
    )
    .map((key) => {
      const val = transform ? transform(key) : key;
      return { key: value[key], value: val };
    });
}
